import { useEffect } from "react";
import HeroSection from "./components/HeroSection.jsx";
import VideoFrame from "./components/VideoFrame.jsx";
import DestaqueHero from "./components/DestaqueHero.jsx";
import WhyBuy from "./components/WhyBuy.jsx";
import MediumBg from './components/MediumBg.jsx';
import FAQ from './components/FAQ.jsx';
import Footer from './components/Footer.jsx';
import { useFadeInOnScroll } from "./components/useFadeInOnScroll";
import ReactPixel from 'react-facebook-pixel';
import TrackLeadSource from './components/TrackLeadSource.jsx';
import './App.css';

function App() {

  useFadeInOnScroll();

  useEffect(() => {
    const fixIOSVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    fixIOSVh();
    window.addEventListener('resize', fixIOSVh, { passive: true });
    window.addEventListener('orientationchange', fixIOSVh, { passive: true });
    return () => {
      window.removeEventListener('resize', fixIOSVh);
      window.removeEventListener('orientationchange', fixIOSVh);
    };
  }, []);

  useEffect(() => {
    ReactPixel.init('1172029754347760');
    ReactPixel.pageView();
  }, []);

  return (
    <div className="App">
        <TrackLeadSource/>
        <HeroSection/>
        <VideoFrame/>
        <DestaqueHero/>
        <WhyBuy/>
        <MediumBg/>
        <FAQ/>
        <Footer/>
    </div>
  );
}

export default App;